import { Box, Button, createStyles, Grid, makeStyles, styled, Tabs, Typography } from '@material-ui/core';
import { COLORS } from 'shared/constants/COLORS';

export const EditProfileCont = styled(Grid)(({ theme }) => ({
  position: 'relative',
  display: 'flex',
  padding: 10,
  flexWrap: 'wrap',
  [theme.breakpoints.down('xs')]: {
    padding: 0,
  },
}));

export const TabHeader = styled(Tabs)(({ theme }) => ({
  backgroundColor: theme.palette.type === 'dark' ? '#151a21' : '#edf1f6',
  color: theme.palette.type === 'dark' ? '#ffffff' : '#151a21',
  marginBottom: 10,
  '& .MuiTab-root': {
    minWidth: 'unset',
  },
  '& .MuiTabs-indicator': {
    backgroundColor: '#3e8bff',
  },
  '& .PrivateTabIndicator-colorSecondary-2381': {
    backgroundColor: 'none',
  },
  [theme.breakpoints.down('xs')]: {
    marginTop: 20,
  },
}));

export const ActiveTabContainer = styled(Box)(() => ({
  flex: 1,
}));

export const TabContainer = styled(Box)(({ theme }) => ({
  background: theme.palette.type === 'dark' ? '#151a21' : '#edf1f6',
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  width: '-webkit-fill-available',
}));

export const AvatarCont = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.type === 'dark' ? '#151a21' : '#edf1f6',
  width: 274,
  height: 369,
  alignSelf: 'center',
  objectFit: 'cover',
  padding: 1,
  borderImageSlice: '1',
  backgroundOrigin: 'border-box',
  backgroundClip: 'content-box, border-box',
  border: 'none',
  backgroundImage:
    theme.palette.type === 'dark'
      ? `linear-gradient(to bottom, #151a21, #151a21), linear-gradient(253deg, #3e8bff, #3e8bff)` // `linear-gradient(to bottom, #151a21, #151a21), linear-gradient(253deg, #d51bff, #00d4ff)
      : `linear-gradient(to bottom, #fff, #fff), linear-gradient(253deg, #3e8bff, #3e8bff)`,
  borderRadius: '10px !important',
  position: 'relative',
  display: 'flex',
  '&:hover': {
    '& .camera-cont': {
      opacity: 1,
    },
  },
}));

export const Avatar = styled('img')(({ theme }) => ({
  backgroundColor: theme.palette.type === 'dark' ? '#151a21' : '#edf1f6',
  width: 257,
  height: 352,
  margin: 8,
  objectFit: 'cover',
}));

export const CameraCont = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.type === 'dark' ? '#151a21' : '#edf1f6',
  position: 'absolute',
  right: 10,
  bottom: 10,
  padding: 10,
  borderRadius: 999,
  opacity: 0,
  width: 50,
  height: 50,
  transition: '100ms',
  cursor: 'pointer',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
}));

export const ButtonCont = styled(Box)(({ theme }) => ({
  marginTop: 20,
  display: 'flex',
  flexDirection: 'column',
  [theme.breakpoints.down('xs')]: {
    width: '100%',
  },
}));

export const InfoCont = styled(Box)(({ theme }) => ({
  background: theme.palette.type === 'dark' ? '#0b0f14' : COLORS.WHITE,
  width: 274,
  // height: 233,
  padding: '21px 25px 35px 25px',
  borderRadius: 8,
  // border: 'solid 1px #2d343e',
  border: '1px solid',
  borderColor: theme.palette.type === 'dark' ? COLORS.DARK_BORDER : COLORS.LIGHT_BORDER,
  marginTop: 20,
  [theme.breakpoints.down('xs')]: {
    width: '100%',
  },
}));

export const SideButton = styled(Button)(({ theme }) => ({
  background: theme.palette.type === 'dark' ? '#0b0f14' : COLORS.WHITE,
  width: 274,
  height: 50,
  // padding: '16px 91px 15px',
  borderRadius: 8,
  // border: 'solid 1px #2d343e',
  border: '1px solid',
  borderColor: theme.palette.type === 'dark' ? COLORS.DARK_BORDER : COLORS.LIGHT_BORDER,
  marginBottom: 10,
  fontSize: 16,
  [theme.breakpoints.down('xs')]: {
    width: '100%',
    marginBottom: 5,
    // height: 40,
    // fontSize: 10,
  },
}));

export const SideInfoCont = styled(Box)(({ theme }) => ({
  background: theme.palette.type === 'dark' ? '#151a21' : '#edf1f6',
  fontFamily: 'Inter',
  marginRight: 24,
  [theme.breakpoints.down('xs')]: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center ',
    marginRight: 0,
  },
}));

export const Name = styled(Typography)(({ theme }) => ({
  fontSize: 25,
  fontWeight: 500,
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: 'normal',
  letterSpacing: '0.89',
  color: theme.palette.type === 'dark' ? '#fff' : '#000',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
}));

export const AgencyName = styled(Typography)(({ theme }) => ({
  fontSize: 16,
  fontWeight: 500,
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: 'normal',
  letterSpacing: 0.57,
  color: COLORS.PRIMARY,
}));

export const Division = styled(Typography)(({ theme }) => ({
  marginTop: 11.5,
  marginBottom: 2,
  fontSiz: 16,
  fontweight: 500,
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: 'normal',
  letterSpacing: 0.57,
  color: theme.palette.type === 'dark' ? '#fff' : '#000',
}));

export const AgencyContact = styled(Typography)(({ theme }) => ({
  fontSize: 16,
  fontWeight: 500,
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: 'normal',
  letterSpacing: 0.57,
  color: theme.palette.type === 'dark' ? COLORS.WHITE : COLORS.BLACK,
}));

export const Completion = styled(Typography)(({ theme }) => ({
  marginRight: 24,
  marginTop: 19.5,
  fontSize: 14,
  fontWeight: 500,
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: 'normal',
  letterSpacing: 0.5,
  marginBottom: 10,
}));

export const useStyles = makeStyles((theme) =>
  createStyles({
    toolTip: {
      color: theme.palette.type === 'dark' ? COLORS.WHITE : COLORS.PRIMARY,
      border: '2px solid',
      borderColor: theme.palette.type === 'dark' ? COLORS.DARK_BORDER : COLORS.LIGHT_BORDER,
      background: theme.palette.type === 'dark' ? '' : COLORS.WHITE,
    },
  }),
);
